import { ReactNode } from "react";

type CircleButtonProps = {
  /** Visible label; may contain <br /> for two-line labels. */
  label: ReactNode;
  /** Accessible name; required when `label` is not a plain string. */
  ariaLabel?: string;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
};

/** Round lime call-to-action (START, NEXT…), same as social-collage. */
const CircleButton = ({
  label,
  ariaLabel,
  icon,
  onClick,
  disabled = false,
  className = "",
}: CircleButtonProps) => (
  <button
    type="button"
    className={`circleButton ${className}`.trim()}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel ?? (typeof label === "string" ? label : undefined)}
  >
    <span className="circleButton__label">{label}</span>
    {icon ? (
      <span className="circleButton__icon" aria-hidden="true">
        {icon}
      </span>
    ) : null}
  </button>
);

export default CircleButton;
